export type DateRangeVariant = (typeof DATE_RANGES_KEYS)[number];
export const DATE_RANGES_KEYS = [
  'today',
  'yesterday',
  'last_7_days',
  'last_14_days',
  'last_30_days',
  'this_week',
  'last_week',
  'this_month',
  'last_month',
  'this_quarter',
  'last_quarter',
  'custom',
] as const;

export const LIGHTWEIGHT_FILTERS_DEFAULT_RANGES_LABELS_MAP: Record<DateRangeVariant, string> = {
  today: 'Today',
  yesterday: 'Yesterday',
  last_7_days: 'Last 7 days',
  last_14_days: 'Last 14 days',
  last_30_days: 'Last 30 days',
  this_week: 'This week',
  last_week: 'Last week',
  this_month: 'This month',
  last_month: 'Last month',
  this_quarter: 'This quarter',
  last_quarter: 'Last quarter',
  custom: 'Custom',
};

export const DEFAULT_DATE_FORMAT_DATE_FNS = 'yyyy-MM-dd';
